// extracted by mini-css-extract-plugin
export default {"container":"IntegratedVideo-module__container","video":"IntegratedVideo-module__video","controls":"IntegratedVideo-module__controls"};